<script lang="ts" setup>
import { ref, onMounted, watch } from 'vue';
import { format } from 'date-fns';

const props = defineProps(['modelValue']);
const emit = defineEmits(['update:modelValue']);
const date = ref(props.modelValue);

onMounted(() => {
    if(props.modelValue == 'today') {
        date.value = new Date();
        emit('update:modelValue', format(date.value, 'yyyy-MM-dd'));
    }
});

watch(date, (newValue) => {
    console.log(newValue);
    if (newValue) {
        emit('update:modelValue', format(newValue, 'yyyy-MM-dd'));
    } else {
        emit('update:modelValue', null);
    }
});
</script>

<template>
    <el-date-picker
        v-model="date"
        class="w-100"
        type="month"
        :editable="false"
        format="MMMM"
        placeholder="Pick a month"
        size="large"
    />
</template>

<style scoped>
.w-100 {
    width: 100%;
}
</style>